"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(_ref) {
  var backgroundColor = _ref.backgroundColor,
      height = _ref.rootHeight,
      width = _ref.rootWidth,
      zIndex = _ref.rootZIndex;
  return {
    backgroundColor: backgroundColor,
    height: height,
    width: width,
    zIndex: zIndex
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJiYWNrZ3JvdW5kQ29sb3IiLCJoZWlnaHQiLCJyb290SGVpZ2h0Iiwid2lkdGgiLCJyb290V2lkdGgiLCJ6SW5kZXgiLCJyb290WkluZGV4Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvU3R5bGVzL1N0eWxlU2V0L1Jvb3QudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gKHtcbiAgYmFja2dyb3VuZENvbG9yLFxuICByb290SGVpZ2h0OiBoZWlnaHQsXG4gIHJvb3RXaWR0aDogd2lkdGgsXG4gIHJvb3RaSW5kZXg6IHpJbmRleFxufTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yLFxuICAgIGhlaWdodCxcbiAgICB3aWR0aCxcbiAgICB6SW5kZXhcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVlLHdCQUtRO0VBQUEsSUFKckJBLGVBSXFCLFFBSnJCQSxlQUlxQjtFQUFBLElBSFRDLE1BR1MsUUFIckJDLFVBR3FCO0VBQUEsSUFGVkMsS0FFVSxRQUZyQkMsU0FFcUI7RUFBQSxJQURUQyxNQUNTLFFBRHJCQyxVQUNxQjtFQUNyQixPQUFPO0lBQ0xOLGVBQWUsRUFBZkEsZUFESztJQUVMQyxNQUFNLEVBQU5BLE1BRks7SUFHTEUsS0FBSyxFQUFMQSxLQUhLO0lBSUxFLE1BQU0sRUFBTkE7RUFKSyxDQUFQO0FBTUQifQ==